import loadable from '@loadable/component';

export const OrgDashboardIntegrationPartnerClientsPageLoadable = loadable(
  () => import('./OrgDashboardIntegrationPartnerClientsPage'),
  {
    resolveComponent: (module) =>
      module.OrgDashboardIntegrationPartnerClientsPage,
  },
);
